import PaymentByChef from './PaymentByChef';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import { connect } from 'react-redux';
import { compose } from 'redux';

const mapStateToProps = ({ }) => ({});
const mapDispatchToProps = {};

export default compose(
   withStyles(styles),
   connect(
      mapStateToProps,
      mapDispatchToProps,
   ),
)(PaymentByChef);

